// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import '@/common/style/reset.css';
import '../../common/style/common.less';
import POINT from '@/common/util/point';
Vue.prototype.POINT = POINT;
import FastClick from 'fastclick';
FastClick.attach(document.body);
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
import '@/common/js/filters';
import Service from './api/network';
Vue.prototype.$http = Service;
import { registerComponents } from './utils/register-components';
registerComponents(Vue);
import '@babel/polyfill';
import promise from 'es6-promise';
require('es6-promise').polyfill();
promise.polyfill();

// 引入app相关配置，如setnavbar，下拉刷新
// import appBridge from '@/common/util/appBridge';
// // 下拉刷新
// appBridge.pullToRefresh();
// 将APP相关函数扩展到每个组件中
// Vue.prototype.$appBridge = appBridge;

// 注册mint-ui组件
const activityType = 32;
Vue.prototype.$activityType = activityType;
const couponsLink = 'https://loanweb.ppdai.com/web/account/coupon/dist/index.html#/';
Vue.prototype.$couponsLink = couponsLink;
import store from './store';
if (process.env.VUE_APP_MOCK === 'yes') require('./api/mock');

window.Promise = Promise;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
